/* eslint-disable react/prop-types */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect, useCallback } from "react";
import { Input } from "reactstrap";

const SearchField = (props) => {
  const [searchValue, setSearchValue] = useState(props.filterParams?.search || '');

  useEffect(() => {
    setSearchValue(props.filterParams?.search || '');
  }, [props.filterParams?.search]);

  // Debounced search function
  const debouncedSearch = useCallback(
    (() => {
      let timeoutId;
      return (value) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          const newFilterParams = {
            ...props.filterParams,
            search: value.trim(), // Use 'search' param for backend
            page: 1 // Reset to first page when searching
          };
          
          if (props.fetchData) {
            props.fetchData(newFilterParams);
          }
        }, 500); // 500ms delay
      };
    })(),
    [props.filterParams, props.fetchData]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    debouncedSearch(value);
  };

  return (
    <div className="search-max-width mb-sm-4">
      <div className="form-icon left">
        <Input
          type="search"
          className="form-control form-control-icon"
          value={searchValue}
          onChange={handleSearchChange}
          id="iconrightInput"
          placeholder="Search...."
        />
        <i className="ri-search-line"></i>
      </div>
    </div>
  );
};

export default SearchField;
